(function() {
    'use strict';
    angular
        .module('ccsTrApp')
        .factory('InvoicePayment', InvoicePayment);

    InvoicePayment.$inject = ['$resource', 'DateUtils'];

    function InvoicePayment ($resource, DateUtils) {
        var resourceUrl =  'api/invoice-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdOn = DateUtils.convertDateTimeFromServer(data.createdOn);
                        data.modifiedOn = DateUtils.convertDateTimeFromServer(data.modifiedOn);
                        data.payDate = DateUtils.convertLocalDateFromServer(data.payDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.payDate = DateUtils.convertLocalDateToServer(data.payDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.payDate = DateUtils.convertLocalDateToServer(data.payDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
